import React, { useState } from "react";
import styled from "styled-components";
import { Image } from "react-feather";
import { Button, ClickAwayListener } from "@mui/material";

const Wrapper = styled(Button)`
  height: 36px;
  width: 100%;
  background: white;
  border: 1px solid #eeeeee;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 8px;
  border-radius: 6px;
  box-shadow: 1px 1px 2px 2px #eeeeee;
`;

const DisplayQuestionImage = ({ image }) => {
  const [open, setOpen] = useState(false);

  return (
    <div style={{ position: "relative" }}>
      <Wrapper onClick={() => setOpen(true)}>
        <span
          style={{
            fontSize: 11,
            lineHeight: 1,
            fontWeight: 500,
            color: "black",
          }}
        >
          View Image
        </span>
        <Image height={13} width={13} color="#337ab7" />
      </Wrapper>
      {open && (
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          <div
            style={{
              width: 200,
              height: 200,
              border: "1px solid darkgrey",
              background: "white",
              position: "absolute",
              top: 100,
              left: "10%",
              padding: 10,
              borderRadius: 6,
              boxShadow: "0px 0px 2px 3px lightgray",
            }}
          >
            <img
              style={{
                height: "100%",
                width: "100%",
                background: "white",
                borderRadius: 6,
              }}
              src={image}
              alt="question"
            />
          </div>
        </ClickAwayListener>
      )}
    </div>
  );
};

export default DisplayQuestionImage;
